
// ==================================================================================== HERO SECTION ENTRY
gsap.set(".co-main-product", { opacity: 0 });
gsap.set(".co-header-spacer", { opacity: 0 });
gsap.to(".co-main-product", {
  opacity: 1,
  duration: 1
});
gsap.to(".co-header-spacer", {
  opacity: 1,
  duration: 1,
  delay: 0.5
});
// D25 Sec 1
gsap.to('.co-product-dec-1', {
  scrollTrigger: {
    trigger: '.co-product-dec-1',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 1,
  ease: 'Power2.inOut'
});
// D25 Sec 2
gsap.to('.co-product-dec-2', {
  scrollTrigger: {
    trigger: '.co-product-dec-2',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 1,
  ease: 'Power2.inOut'
});
// D25 Sec 3
gsap.to('.co-product-dec-3', {
  scrollTrigger: {
    trigger: '.co-product-dec-3',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 1,
  ease: 'Power2.inOut'
});
// D25 Sec 4
gsap.to('.co-product-dec-4', {
  scrollTrigger: {
    trigger: '.co-product-dec-4',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 1,
  ease: 'Power2.inOut'
});
// D25 Sec 5
gsap.to('.co-product-dec-5', {
  scrollTrigger: {
    trigger: '.co-product-dec-5',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 1,
  ease: 'Power2.inOut'
});
// D25 Sec 6
gsap.to('.co-product-dec-6', {
  scrollTrigger: {
    trigger: '.co-product-dec-6',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 1,
  ease: 'Power2.inOut'
});

// ==================================================================================== HERO SECTION

// if (!document.documentElement.classList.contains('shopify-design-mode')) {
//   coMM.add("(min-width: 750px)", () => {
//     const trigger = document.querySelector(".co-main-product");
//     const pinned = document.querySelector(".co-product-left-column-pin");
//     const infoWrapper = document.querySelector(".product__info-wrapper > section");
    
//     let pinInstance = null;
    
//     function createOrUpdatePin() {
//       const shouldPin = infoWrapper.offsetHeight > pinned.offsetHeight;
      
//       if (shouldPin && !pinInstance) {
//         pinInstance = ScrollTrigger.create({
//           trigger: trigger,
//           start: "top top",
//           end: () => `+=${trigger.offsetHeight - pinned.offsetHeight}`,
//           pinSpacing: false,
//           pin: pinned
//         });
//       } else if (!shouldPin && pinInstance) {
//         pinInstance.kill();
//         pinInstance = null;
//       } else if (pinInstance) {
//         pinInstance.refresh();
//       }
//     }
    
//     createOrUpdatePin();
//     ScrollTrigger.addEventListener("refresh", createOrUpdatePin);
//   });
// }

if (!document.documentElement.classList.contains('shopify-design-mode')) {
  coMM.add("(min-width: 750px)", () => {
    const trigger = document.querySelector(".co-main-product");
    const pinned = document.querySelector(".co-product-left-column-pin");
    const infoWrapper = document.querySelector(".product__info-wrapper > section");
    
    let pinInstance = null;
    
    function createOrUpdatePin() {
      const shouldPin = infoWrapper.offsetHeight > pinned.offsetHeight;
      
      if (shouldPin && !pinInstance) {
        pinInstance = ScrollTrigger.create({
          trigger: trigger,
          start: "top top",
          end: () => `+=${trigger.offsetHeight - pinned.offsetHeight}`,
          pinSpacing: false,
          pin: pinned
        });
      } else if (!shouldPin && pinInstance) {
        pinInstance.kill();
        pinInstance = null;
      } else if (pinInstance) {
        pinInstance.refresh();
      }
    }
    
    createOrUpdatePin();
    ScrollTrigger.addEventListener("refresh", createOrUpdatePin);
    
    // Return a cleanup function that runs when media query no longer matches
    return () => {
      ScrollTrigger.removeEventListener("refresh", createOrUpdatePin);
      if (pinInstance) {
        pinInstance.kill();
        pinInstance = null;
      }
    };
  });
}


// function createAccordionAnimation(
//   containerSelector,
//   groupSelector,
//   menuSelector,
//   contentSelector,
//   openIconSelector,
//   closeIconSelector,
//   options = {}
// ) {
//   // Default options
//   const settings = {
//     initialOpen: [],
//     multi: false,
//     activeClass: 'is-active', // Class to add when accordion is open
//     ...options
//   };

//   let groups = gsap.utils.toArray(groupSelector, document.querySelector(containerSelector));
//   let menus = gsap.utils.toArray(menuSelector, document.querySelector(containerSelector));
//   let menuToggles = groups.map(createAnimation);

//   menus.forEach((menu) => {
//     menu.addEventListener("click", () => toggleMenu(menu));
//   });

//   function toggleMenu(clickedMenu) {
//     menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
//     gsap.delayedCall(0.3, () => ScrollTrigger.refresh());
//   }

//   function createAnimation(element) {
//     let menu = element.querySelector(menuSelector);
//     let box = element.querySelector(contentSelector);
//     let minusElement = element.querySelector(openIconSelector);
//     let plusElement = element.querySelector(closeIconSelector);

//     gsap.set(box, { height: "auto" });

//     let animation = gsap
//       .timeline()
//       .from(box, {
//         height: 0,
//         duration: 0.3,
//         ease: "power2.inOut",
//         onComplete: () => ScrollTrigger.refresh()
//       })
//       .from(minusElement, { duration: 0.1, autoAlpha: 0, ease: "none" }, 0)
//       .to(plusElement, { duration: 0.1, autoAlpha: 0, ease: "none" }, 0)
//       .reverse();

//     return function (clickedMenu) {
//       if (clickedMenu === menu) {
//         animation.reversed(!animation.reversed());
//         element.classList.toggle(settings.activeClass, !animation.reversed());
//       } else if (!settings.multi) {
//         animation.reverse();
//         element.classList.remove(settings.activeClass);
//       }
//     };
//   }

//   // Open specified accordions initially
//   if (settings.initialOpen.length > 0 && menus.length > 0) {
//     settings.initialOpen.forEach((index) => {
//       if (index >= 0 && index < menus.length) {
//         toggleMenu(menus[index]);
//       }
//     });
//   }
// }


// // ========================================== ACCORDION FUNCTION

// createAccordionAnimation(
//   ".co-product-hero-accordion", 
//   ".co-product-hero-accordion-group",
//   ".co-product-hero-accordion-menu",  
//   ".co-product-hero-accordion-content", 
//   ".co-product-hero-accordion-open",   
//   ".co-product-hero-accordion-close",
//   { initialOpen: [2], multi: true, activeClass: 'is-active' }
// );

function createAccordionAnimation(
  containerSelector,
  groupSelector,
  menuSelector,
  contentSelector,
  openIconSelector,
  closeIconSelector,
  options = {}
) {
  const settings = {
    initialOpen: [],
    multi: false,
    activeClass: 'is-active',
    ...options
  };

  const container = document.querySelector(containerSelector);
  if (!container) return;

  let groups = gsap.utils.toArray(groupSelector, container);
  let menus = gsap.utils.toArray(menuSelector, container);
  let menuToggles = groups.map(createAnimation);
  let openBoxes = [];

  menus.forEach((menu) => {
    menu.addEventListener("click", () => toggleMenu(menu));
  });

  function toggleMenu(clickedMenu) {
    menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
    gsap.delayedCall(0.3, () => ScrollTrigger.refresh());
  }

  // Handle resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      openBoxes.forEach((box) => {
        gsap.set(box, { height: "auto" });
      });
      ScrollTrigger.refresh();
    }, 150);
  });

  function createAnimation(element) {
    let menu = element.querySelector(menuSelector);
    let box = element.querySelector(contentSelector);
    let minusElement = element.querySelector(openIconSelector);
    let plusElement = element.querySelector(closeIconSelector);

    let isOpen = false;
    let animation = null;

    // Set initial closed state
    gsap.set(box, { height: 0, overflow: "hidden" });
    gsap.set(minusElement, { autoAlpha: 0 });
    gsap.set(plusElement, { autoAlpha: 1 });

    function getHeight() {
      gsap.set(box, { height: "auto" });
      const h = box.scrollHeight;
      if (!isOpen) {
        gsap.set(box, { height: 0 });
      }
      return h;
    }

    function open() {
      isOpen = true;
      element.classList.add(settings.activeClass);
      openBoxes.push(box);
      
      if (animation) animation.kill();
      
      const initialHeight = getHeight();
      
      animation = gsap.timeline()
        .to(box, {
          height: initialHeight,
          duration: 0.3,
          ease: "power2.inOut",
          onComplete: () => {
            gsap.set(box, { height: "auto" });
            ScrollTrigger.refresh();
          }
        })
        .to(minusElement, { duration: 0.1, autoAlpha: 1, ease: "none" }, 0)
        .to(plusElement, { duration: 0.1, autoAlpha: 0, ease: "none" }, 0);

      // Check for images and adjust height after they load
      const images = box.querySelectorAll("img");
      images.forEach((img) => {
        if (!img.complete || img.naturalHeight === 0) {
          img.onload = () => {
            if (isOpen) {
              gsap.set(box, { height: "auto" });
              ScrollTrigger.refresh();
            }
          };
        }
      });
    }

    function close() {
      if (animation) animation.kill();
      
      // Remove from openBoxes array
      openBoxes = openBoxes.filter((b) => b !== box);
      
      const currentHeight = box.scrollHeight;
      gsap.set(box, { height: currentHeight });
      
      animation = gsap.timeline()
        .to(box, {
          height: 0,
          duration: 0.3,
          ease: "power2.inOut",
          onComplete: () => ScrollTrigger.refresh()
        })
        .to(minusElement, { duration: 0.1, autoAlpha: 0, ease: "none" }, 0)
        .to(plusElement, { duration: 0.1, autoAlpha: 1, ease: "none" }, 0);

      isOpen = false;
      element.classList.remove(settings.activeClass);
    }

    return function (clickedMenu) {
      if (clickedMenu === menu) {
        if (!isOpen) {
          open();
        } else {
          close();
        }
      } else if (!settings.multi && isOpen) {
        close();
      }
    };
  }

  // Open specified accordions initially
  if (settings.initialOpen.length > 0 && menus.length > 0) {
    setTimeout(() => {
      settings.initialOpen.forEach((index) => {
        if (index >= 0 && index < menus.length) {
          toggleMenu(menus[index]);
        }
      });
    }, 100);
  }
}

// ========================================== ACCORDION FUNCTION

createAccordionAnimation(
  ".co-product-hero-accordion", 
  ".co-product-hero-accordion-group",
  ".co-product-hero-accordion-menu",  
  ".co-product-hero-accordion-content", 
  ".co-product-hero-accordion-open",   
  ".co-product-hero-accordion-close",
  { initialOpen: [2], multi: true, activeClass: 'is-active' }
);



// ========================================================================================================== REUSABLE MARQUEE FUNCTION
function coInitializeTickerCarousel({ 
  selector = '', 
  tickerSpeed = 1, 
  prevNextButtons = true,
  rightScroll = false 
}) {
  let flickity = null;
  let isPaused = false;
  const slideshowEl = document.querySelector(selector);
  if (!slideshowEl) {
    console.error(`Element with selector "${selector}" not found.`);
    return;
  }
  const update = () => {
    if (isPaused) return;
    if (flickity.slides) {
      const direction = rightScroll ? tickerSpeed : -tickerSpeed;
      flickity.x = (flickity.x + direction) % flickity.slideableWidth;
      flickity.selectedIndex = flickity.dragEndRestingSelect();
      flickity.updateSelectedSlide();
      flickity.settle(flickity.x);
    }
    window.requestAnimationFrame(update);
  };
  const pause = () => {
    isPaused = true;
  };
  const play = () => {
    if (isPaused) {
      isPaused = false;
      window.requestAnimationFrame(update);
    }
  };
  flickity = new Flickity(slideshowEl, {
    autoPlay: false,
    pageDots: false,
    draggable: true,
    prevNextButtons: prevNextButtons,
    wrapAround: true,
    selectedAttraction: 0.015,
    friction: 0.25,
    on: {
      ready: function() {
    
      }
    }
  });
  flickity.x = 0;
  slideshowEl.addEventListener('mouseenter', pause, false);
  slideshowEl.addEventListener('focusin', pause, false);
  slideshowEl.addEventListener('mouseleave', play, false);
  slideshowEl.addEventListener('focusout', play, false);
  flickity.on('dragStart', () => {
    isPaused = true;
  });
  update();
}
// ========================================================================================================== SECTION 1 (DEC25)
// ===================================================== MARQUEE
const coProductSection3 = document.querySelector('.co-product-dec-1-slider');
if (coProductSection3) {
  coInitializeTickerCarousel({ selector: '.co-product-dec-1-slider', tickerSpeed: 0.5, prevNextButtons: true, rightScroll: false });
}
// ========================================================================================================== SECTION 3 (DEC25)
(function() {
  'use strict';
  
  function setEqualHeights() {
    const titleElements = document.querySelectorAll('.co-product-dec-3-article-title');
    
    if (titleElements.length === 0) return;
    
    titleElements.forEach(el => el.style.height = 'auto');
    
    let maxHeight = 0;
    titleElements.forEach(el => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    titleElements.forEach(el => {
      el.style.height = maxHeight + 'px';
    });
  }

  const flkty = new Flickity('.co-product-dec-3-slider', {
    pageDots: false, 
    draggable: true,
    prevNextButtons: false,
    cellAlign: "left",
    contain: true,
    on: {
      ready: function() {
        setEqualHeights();
      },
      settle: function() {
        setEqualHeights();
      }
    }
  });
  
  window.addEventListener('resize', function() {
    flkty.resize();
    setEqualHeights();
  });
})();

// ========================================================================================================== VIDEO
(function() {
  'use strict';
    const hoverVideos = document.querySelectorAll('.co-hover-video');
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (isTouchDevice) {
      hoverVideos.forEach(video => {
        video.setAttribute('autoplay', '');
        video.play();
      });
    } else {
      hoverVideos.forEach(video => {
        // Force first frame to render
        video.play().then(() => {
          video.pause();
          video.currentTime = 0;
        }).catch(() => {});
        
        video.addEventListener('mouseenter', () => {
          video.play();
        });
        
        video.addEventListener('mouseleave', () => {
          video.pause();
        });
      });
    }
})();


// ========================================================================================================== SECTION 4 (DEC25)
// class ImageCompare {
//   constructor(element) {
//     this.element = element;
//     this.overlay = element.querySelector('.co-image-compare-overlay');
//     this.slider = element.querySelector('.co-image-compare-slider');
//     this.overlayImageWrapper = this.overlay.querySelector('.co-product-dec-4-compare-image');
//     this.isResizing = false;

//     this.init();
//   }

//   init() {
//     this.updateDimensions();

//     this.slider.addEventListener('mousedown', (e) => this.startResize(e));
//     this.element.addEventListener('mousedown', (e) => this.startResize(e));

//     this.slider.addEventListener('touchstart', (e) => this.startResize(e));
//     this.element.addEventListener('touchstart', (e) => this.startResize(e));

//     window.addEventListener('resize', () => this.updateDimensions());
//   }

//   updateDimensions() {
//     const width = this.element.offsetWidth;
//     if (this.overlayImageWrapper) {
//       this.overlayImageWrapper.style.width = width + 'px';
//       const img = this.overlayImageWrapper.querySelector('img');
//       if (img) {
//         img.style.width = width + 'px';
//       }
//     }
//   }

//   startResize(e) {
//     e.preventDefault();
//     this.isResizing = true;

//     const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
//     this.updatePosition(x);

//     const moveHandler = (e) => this.resize(e);
//     const endHandler = () => this.endResize(moveHandler, endHandler);

//     if (e.type.includes('touch')) {
//       document.addEventListener('touchmove', moveHandler);
//       document.addEventListener('touchend', endHandler);
//     } else {
//       document.addEventListener('mousemove', moveHandler);
//       document.addEventListener('mouseup', endHandler);
//     }
//   }

//   resize(e) {
//     if (!this.isResizing) return;

//     const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
//     this.updatePosition(x);
//   }

//   updatePosition(x) {
//     const rect = this.element.getBoundingClientRect();
//     let position = x - rect.left;

//     position = Math.max(0, Math.min(position, rect.width));

//     const percentage = (position / rect.width) * 100;

//     this.overlay.style.width = percentage + '%';
//     this.slider.style.left = percentage + '%';
//   }

//   endResize(moveHandler, endHandler) {
//     this.isResizing = false;

//     document.removeEventListener('mousemove', moveHandler);
//     document.removeEventListener('mouseup', endHandler);
//     document.removeEventListener('touchmove', moveHandler);
//     document.removeEventListener('touchend', endHandler);
//   }
// }

// document.addEventListener('DOMContentLoaded', () => {
//   const comparison = document.querySelector('[data-comparison]');
//   if (comparison) {
//     new ImageCompare(comparison);
//   }
// });

// document.querySelectorAll('.co-product-dec-4-header-text').forEach(el => {
//   el.innerHTML = el.innerHTML.replace(/\bvs\b/gi, '<span class="co-product-dec-4-header-vs brandon-grotesque-black-regular">vs</span>');
// });

// ========================================================================================================== SECTION 5 (DEC25)
(function() {
  'use strict';

  const flkty = new Flickity('.co-product-dec-5-slider', {
    pageDots: false, 
    draggable: true,
    wrapAround: true,
    prevNextButtons: false,
    cellAlign: "center",
    contain: true,
    on: {

    }
  });
  
})();
// ========================================================================================================== SECTION 6 (DEC25)
let coRegen8Groups = gsap.utils.toArray(".co-product-dec-6-accordion-group");
let coRegen8Menus = gsap.utils.toArray(".co-product-dec-6-accordion-menu");
let coRegen8MenuToggles = coRegen8Groups.map(createAnimation);
coRegen8Menus.forEach((menu) => {
  menu.addEventListener("click", () => coRegen8ToggleMenu(menu));
});
function coRegen8ToggleMenu(clickedMenu) {
  coRegen8MenuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
}
function createAnimation(element) {
  let menu = element.querySelector(".co-product-dec-6-accordion-menu");
  let box = element.querySelector(".co-product-dec-6-accordion-content");
  let minusElement = element.querySelector(".co-product-dec-6-accordion-open");
  let plusElement = element.querySelector(".co-product-dec-6-accordion-close");
  gsap.set(box, { height: "auto" });
  let animation = gsap
    .timeline()
    .from(box, {
      height: 0,
      duration: 0.3,
      ease: "power2.inOut"
    })
    .from(minusElement, { duration: 0.1, autoAlpha: 0, ease:"none" }, 0)
    .to(plusElement, { duration: 0.1, autoAlpha: 0, ease:"none" }, 0)
    .reverse();

  return function (clickedMenu) {
    if (clickedMenu === menu) {
      animation.reversed(!animation.reversed());
    } else {
      animation.reverse();
    }
  };
}
coRegen8ToggleMenu(coRegen8Menus[0])
